/* eslint-disable react/prop-types */ // TODO: add props
import { Popover } from 'react-bootstrap';
import _ from 'lodash';
/** Components */
// TODO(dc): domainify
import WarningIndicator from 'edrolo/components/common/WarningIndicator';
import TrafficLightIndicator from 'edrolo/components/exams/grid/TrafficLightIndicator';
import { EXAM_QUESTION_TYPES } from 'edrolo/constants/QuestionTypes';

const getTeacherReviewedPercentage = (question, sittings) => {
  // We only care about self marked questions
  if (
    question.question_type === EXAM_QUESTION_TYPES.SINGLE_ANSWER_MULTI_CHOICE
  ) {
    return null;
  }

  // Loop student sittings
  const responses = sittings.map((sitting) =>
    _.find(sitting.responses, { question: question.id })
  );

  // Filter by teacher marked
  const teacherMarked = responses.filter((response) => {
    return (
      response &&
      (response.text_marks_from_teacher !== null ||
        !_.isEmpty(response.comment_from_teacher))
    );
  });

  return (teacherMarked.length / responses.length) * 100;
};

const QuestionAverageCell = ({ sittingData, question, average }) => {
  const submittedSittings = sittingData.filter(
    (sitting) => !!sitting.submitted_ts
  );
  if (!_.isNumber(average)) {
    return <span>-</span>;
  }

  const popoverText = `Your students scored an average of ${average}% for this question`;
  const popover = <Popover id={_.uniqueId()}>{popoverText}</Popover>;

  // Warn if teacher reviewed is low!
  const teacherReviewedPercentage = getTeacherReviewedPercentage(
    question,
    submittedSittings
  );

  let warningIndicator;
  if (teacherReviewedPercentage < 75) {
    const message = teacherReviewedPercentage ? (
      <span>
        Only{' '}
        <b>
          {Math.round(teacherReviewedPercentage)}% of these answers have been
          corrected or commented on
        </b>{' '}
        by this class’ teacher
      </span>
    ) : (
      <span>
        <b>None of these answers have been corrected or commented on</b> by this
        class’ teacher
      </span>
    );
    warningIndicator = <WarningIndicator message={message} />;
  }

  return (
    <div className="indicator-container">
      <TrafficLightIndicator
        a={average}
        b={question.vcaa_average}
        popover={popover}
      >
        {average}%
      </TrafficLightIndicator>
      {warningIndicator}
    </div>
  );
};

export default QuestionAverageCell;
